import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Button } from "../components/ui/button";
import { ArrowRight } from "lucide-react";
import EnquiryModal from "../components/EnquiryModal";
import { BrandLogo, refreshSiteConfig } from "../lib/siteConfig";
import { HeroSection } from "../components/landing/HeroSection";
import { EstateGrid } from "../components/landing/EstateGrid";
import { FeaturesSection } from "../components/landing/FeaturesSection";
import { CottageSection } from "../components/landing/CottageSection";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Landing() {
  const [projects, setProjects] = useState([]);
  const [enquiry, setEnquiry] = useState(null);

  useEffect(() => {
    axios.get(`${API}/projects/public`).then((r) => setProjects(r.data)).catch(() => setProjects([]));
    refreshSiteConfig();
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-30 bg-background/85 backdrop-blur-xl border-b border-border">
        <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <BrandLogo size={36} />
            <div className="heading text-base md:text-lg font-semibold leading-tight">Roots by Sanjeevani Farms</div>
          </div>
          <div className="flex items-center gap-2">
            <a href="#projects"><Button variant="ghost" data-testid="projects-nav-btn">Projects</Button></a>
            <Link to="/login"><Button variant="ghost" data-testid="login-nav-btn">Sign in</Button></Link>
            <Link to="/register"><Button data-testid="get-started-btn">Get started <ArrowRight size={14} className="ml-1" /></Button></Link>
          </div>
        </div>
      </header>

      <HeroSection projects={projects} />
      <EstateGrid projects={projects} onEnquire={setEnquiry} />
      <FeaturesSection />
      <CottageSection />

      <footer className="border-t border-border py-8 text-center text-xs text-muted-foreground">
        © 2026 Roots by Sanjeevani Farms · Managed farmland operations, structured.
      </footer>

      <EnquiryModal open={!!enquiry} onOpenChange={(o) => !o && setEnquiry(null)} project={enquiry} />
    </div>
  );
}
